import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/calltree', label: 'CallTree' },
  { path: '/activities', label: 'Activities' },
  { path: '/agri-products', label: 'Agri Products' },
  { path: '/contact', label: 'Join Us' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="header__inner container">
        <Link to="/" className="header__logo">
          <img
            src="/images/Y2K logo.png"
            alt="Y2K Global Nexus"
            className="header__logo-img"
          />
          <div className="header__logo-text">
            <span className="header__logo-brand">Y2K Global Nexus</span>
            <span className="header__logo-sub">calltree.in</span>
          </div>
        </Link>

        <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
          {navLinks.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={`header__nav-link ${location.pathname === path ? 'header__nav-link--active' : ''}`}
            >
              {label}
            </Link>
          ))}
          <Link to="/contact" className="btn-primary header__cta">
            🌱 Plant a Tree
          </Link>
        </nav>

        <button
          className={`header__hamburger ${menuOpen ? 'header__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
